





















import { PropType, defineComponent } from '@vue/composition-api';
import { Message } from '../../dataType';

export default defineComponent({
  props: {
    message: {
      type: Object as PropType<Message<any>>,
      required: true
    },
    title: {
      type: String as PropType<string>,
      default: ''
    },
    titleClass: {
      type: String as PropType<string>,
      default: ''
    },
    showTitle: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    showBody: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    border: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    fullWidth: {
      type: Boolean as PropType<boolean>,
      default: true
    }
  },
  setup() {

  }
});
